import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import 'rxjs/add/operator/map'

@Injectable()
export class AuthenticationService {

    constructor(private router: Router, private http: HttpClient) {
    }
    isAuthorized() {
        return localStorage.getItem("token") != null;
    }

    isAdministrator() {
        return localStorage.getItem("token") != null
            && localStorage.getItem("storeName") != null
            && (localStorage.getItem("polenUserRole").indexOf("Administrador") >= 0
                || (localStorage.getItem("admin-polenUserRole") != null && localStorage.getItem("admin-polenUserRole").indexOf("Administrador") >= 0));
    }

    hasCompanySelected() {
        return localStorage.getItem("companyMaskId") != null;
    }

    getCompanySelected() {
        return localStorage.getItem("companyMaskId");
    }

    getAccountName() {
        if (localStorage.getItem("accountName") != null && localStorage.getItem("accountName") != "null") {
            return localStorage.getItem("accountName");
        }
        return "Polinizador";
    }

    hasStoreSelected() {
        return localStorage.getItem("storeMaskId") != null && localStorage.getItem("storeName") != null;
    }

    getStoreSelected() {
        return localStorage.getItem("storeMaskId");
    }

    getAccountApiToken() {
        debugger
        var extraJson = localStorage.getItem("extraInfos");
        var extra = JSON.parse(extraJson);
        if (extra != null && extra.length > 0) {
            return extra[0].userToken
        }

        return null;
    }

    countTotalStores() {
        return parseInt(localStorage.getItem("storeTotal"));
    }

    isImpersonatedButAdmin() {
        return localStorage.getItem("admin-token") != null
    }

    login(username: string, password: string, polenCode?: string): any {
        debugger
        let headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if ((password == null || password.length == 0) && polenCode != null) {
            password = "polenCode$" + polenCode;
        }

        let body = new HttpParams()
            .set('username', username)
            .set('password', password)
            .set('scope', 'store')
            .set('grant_type', "password");

        return this.http.post(Configuration.apiUrl + 'account/login', body.toString(), { headers: headers })
    }

    getStoreList() {
        var strStoreList = localStorage.getItem("storeList");
        if (strStoreList != null)
            return JSON.parse(strStoreList);
        return null;
    }

    getFeatureList() {
        var features = localStorage.getItem("storeFeatures");
        if (features != null)
            return JSON.parse(features);
        return null;
    }

    hasFeature(feature) {
        var features = localStorage.getItem("storeFeatures");
        if (features != null) {
            var list = JSON.parse(features);
            if (list != null) {
                return list.indexOf(feature) >= 0
            }
        }

        return false;
    }

    getProfilePlanInfo() {
        const now = new Date()
        var json = localStorage.getItem("storeProfilePlanInfo");
        if (json != null) {
            var item = JSON.parse(json);
            if (item.expiry == undefined)
                return null;

            //garante que é removido se foi criado a mais de uma hora para forçar atualização
            if (now.getTime() > item.expiry) {
                this.removeProfilePlanInfo();
                return null;
            }

            return item.value;
        }

        return null;
    }

    setProfilePlanInfo(profilePlan: any) {
        const now = new Date()
        const item = {
            value: profilePlan,
            expiry: now.getTime() + 3.6e+6, //adiciona uma hora em milisegundos
        }
        localStorage.setItem("storeProfilePlanInfo", JSON.stringify(item))
    }

    removeProfilePlanInfo() {
        localStorage.removeItem("storeProfilePlanInfo")
    }

    loginToStoreById(id: string) {
        debugger
        var storeList = this.getStoreList();
        if (storeList != null) {
            var store = storeList.find(x => x.storeId == id);
            if (store != null && store != undefined) {
                this.loginToStore(store);
                return true;
            }
            else {
                console.log('Loja ñ encontrada: storeId: ' + id);
            }

        }
        return false;
    }

    loginToCompany(company: any) {
        localStorage.setItem("companyMaskId", company.companyId)
        localStorage.setItem("companyName", company.companyName)
        localStorage.setItem("accountId", company.accountId)
        //TODO adicionar userRole tbem?
    }

    loginToStore(store: any) {
        localStorage.setItem("storeMaskId", store.storeId)
        localStorage.setItem("storeName", store.storeName)
        localStorage.setItem("accountName", store.accountName)
        localStorage.setItem("accountEmail", store.accountEmail)
        localStorage.setItem("storePlatform", store.storePlatform)
        localStorage.setItem("polenUserRole", store.userRole)
        localStorage.setItem("storeFeatures", JSON.stringify(store.features))
    }

    logoutFromCompany() {
        localStorage.removeItem("companyMaskId")
        localStorage.removeItem("companyName")
        localStorage.removeItem("accountId")
        this.logoutFromStore();
    }

    //volta para a visualizacao de company
    logoutFromStore() {
        localStorage.removeItem("storeMaskId")
        localStorage.removeItem("storeName")
        localStorage.removeItem("accountName")
        localStorage.removeItem("accountEmail")
        localStorage.removeItem("storePlatform")
        localStorage.removeItem("storeFeatures")
        localStorage.removeItem("storeProfilePlanInfo")
        localStorage.removeItem("polenUserRole")
        //this.router.navigate(['/company/store'])
        window.location.href = "/#/company/list"
    }

    logout() {
        localStorage.removeItem('token')
        localStorage.removeItem('polenPainelCustomized')
        localStorage.removeItem("storePlatform")
        localStorage.removeItem("storeName")
        localStorage.removeItem("storeFeatures")
        localStorage.removeItem("storeProfilePlanInfo")
        localStorage.removeItem("accountName")
        localStorage.removeItem("accountEmail")
        localStorage.removeItem("storeMaskId")
        localStorage.removeItem("polenUserRole")
        localStorage.removeItem("storeTotal")
        localStorage.removeItem("companyMaskId")
        localStorage.removeItem("companyName")
        localStorage.removeItem("storeList")
        localStorage.removeItem("accountId")
        localStorage.removeItem("extraInfos")
        localStorage.removeItem("companyList")
        localStorage.removeItem("admin-token")
        localStorage.removeItem("admin-storeName")
        localStorage.removeItem("admin-accountName")
        localStorage.removeItem("admin-accountEmail")
        localStorage.removeItem("admin-storeList")
        localStorage.removeItem("admin-storeTotal")
        localStorage.removeItem("admin-storePlatform")
        localStorage.removeItem("admin-polenUserRole")
        localStorage.removeItem("admin-extraInfos")
        localStorage.removeItem("admin-companyList")

        //storage do ngoPanel
        localStorage.removeItem('polenNgoToken')
        localStorage.removeItem('polenUserRole')
        localStorage.removeItem('polenNgoUrl')
        localStorage.removeItem('polenNgoLogo')
        localStorage.removeItem('polenNgoName')
        localStorage.removeItem('polenNgoId')
        localStorage.removeItem("polenAdmin")
        localStorage.removeItem("tempSave")

        localStorage.removeItem('admin-token')
        localStorage.removeItem('admin-polenNgoName')
        localStorage.removeItem('admin-polenNgoLogo')
        localStorage.removeItem('admin-polenUserRole')

        this.router.navigate(['/pages/login'])
    }

    requestForgotPasswordEmail(email, type) {
        return this.http.get(Configuration.apiUrl + 'Api/Account/RequestForgotPasswordEmail?email=' + email + "&type=" + type)
    }

    changePasswordFromToken(changePasswordModel): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/Account/ChangePasswordFromToken', JSON.stringify(changePasswordModel), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    changePassword(changePasswordModel): any {
        return this.http.post(Configuration.apiUrl + 'Api/Account/ChangePassword', JSON.stringify(changePasswordModel), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    Impersonate(email, path): any {
        debugger
        this.removeProfilePlanInfo()

        if (localStorage.getItem("admin-token") == null) {
            localStorage.setItem("admin-token", localStorage.getItem("token"))
            localStorage.setItem("admin-companyList", localStorage.getItem("companyList"))
            localStorage.setItem("admin-storeList", localStorage.getItem("storeList"))
            localStorage.setItem("admin-storeTotal", localStorage.getItem("storeTotal"))
            localStorage.setItem("admin-storeName", localStorage.getItem("storeName"))
            localStorage.setItem("admin-accountName", localStorage.getItem("accountName"))
            localStorage.setItem("admin-accountEmail", localStorage.getItem("accountEmail"))
            localStorage.setItem("admin-storePlatform", localStorage.getItem("storePlatform"))
            localStorage.setItem("admin-polenUserRole", localStorage.getItem("polenUserRole"))
            localStorage.setItem("admin-extraInfos", localStorage.getItem("extraInfos"))

        }

        this.login(email, "#polenM@aster").subscribe(data => {
            debugger
            if (data != null) {
                console.log("/aqui")
                console.log(data)
                var storeList = JSON.parse(data.storeList);
                localStorage.setItem("companyList", data.companyList);
                localStorage.setItem("storeList", data.storeList)
                localStorage.setItem("storeTotal", data.storeList.length)
                localStorage.setItem("extraInfos", data.extraInfo);
                localStorage.setItem("token", data.access_token)

                //se soh tiver uma loja, então ele já loga direto.
                //para logar direto precisa ter populado o "storeId" no localStoreage
                if (storeList != null && storeList.length == 1) {
                    var store = storeList[0];
                    this.loginToStore(store);
                    if (path != null)
                        window.open('/' + path, '_blank');
                    else
                        window.open('/', '_blank');
                } else {

                    window.open('/#/company/list', '_blank');
                }

            }
            else {
                console.log('nao foi encontrado loja com o email: ' + email);
            }

            // localStorage.setItem("token", data.access_token)
            // localStorage.setItem("storeName", data.storeName)
            // localStorage.setItem("storePlatform", data.storePlatform)
            // localStorage.setItem("polenUserRole", data.userRole)
            //window.location.href = "/"

        }, err => {
            console.log(err)
        })
    }

    Deimpersonate(): any {
        debugger
        var list = JSON.parse(localStorage.getItem("admin-storeList"));
        localStorage.setItem("token", localStorage.getItem("admin-token"))
        localStorage.setItem("storeName", localStorage.getItem("admin-storeName"))
        localStorage.setItem("accountName", localStorage.getItem("admin-accountName"))
        localStorage.setItem("accountEmail", localStorage.getItem("admin-accountEmail"))
        localStorage.setItem("storePlatform", localStorage.getItem("admin-storePlatform"))
        localStorage.setItem("polenUserRole", localStorage.getItem("admin-polenUserRole"))
        localStorage.setItem("storeList", localStorage.getItem("admin-storeList"))
        localStorage.setItem("storeTotal", localStorage.getItem("admin-storeTotal"))
        localStorage.setItem("storeMaskId", list[0].storeId)
        localStorage.removeItem("polenAdmin")
        localStorage.removeItem("tempSave")
        localStorage.removeItem("admin-token")
        localStorage.removeItem("admin-storeName")
        localStorage.removeItem("admin-accountName")
        localStorage.removeItem("admin-accountEmail")
        localStorage.removeItem("admin-companyList")
        localStorage.removeItem("admin-storeList")
        localStorage.removeItem("admin-storeTotal")
        localStorage.removeItem("admin-storePlatform")
        localStorage.removeItem("admin-polenUserRole")
        localStorage.removeItem("admin-extraInfos")
        this.removeProfilePlanInfo()
        window.location.href = "/"
    }
}
